/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    V1LabelSelector,
    V1LabelSelectorFromJSON,
    V1LabelSelectorFromJSONTyped,
    V1LabelSelectorToJSON,
} from './V1LabelSelector';

/**
 * ClusterTrustBundleProjection describes how to select a set of
 * ClusterTrustBundle objects and project their contents into the pod
 * filesystem.
 * @export
 * @interface V1ClusterTrustBundleProjection
 */
export interface V1ClusterTrustBundleProjection {
    /**
     * 
     * @type {V1LabelSelector}
     * @memberof V1ClusterTrustBundleProjection
     */
    labelSelector?: V1LabelSelector;
    /**
     * Select a single ClusterTrustBundle by object name.  Mutually-exclusive
     * with signerName and labelSelector.
     * +optional
     * @type {string}
     * @memberof V1ClusterTrustBundleProjection
     */
    name?: string;
    /**
     * If true, don't block pod startup if the referenced ClusterTrustBundle(s)
     * aren't available.  If using name, then the named ClusterTrustBundle is
     * allowed not to exist.  If using signerName, then the combination of
     * signerName and labelSelector is allowed to match zero
     * ClusterTrustBundles.
     * +optional
     * @type {boolean}
     * @memberof V1ClusterTrustBundleProjection
     */
    optional?: boolean;
    /**
     * Relative path from the volume root to write the bundle.
     * @type {string}
     * @memberof V1ClusterTrustBundleProjection
     */
    path?: string;
    /**
     * Select all ClusterTrustBundles that match this signer name.
     * Mutually-exclusive with name.  The contents of all selected
     * ClusterTrustBundles will be unified and deduplicated.
     * +optional
     * @type {string}
     * @memberof V1ClusterTrustBundleProjection
     */
    signerName?: string;
}

export function V1ClusterTrustBundleProjectionFromJSON(json: any): V1ClusterTrustBundleProjection {
    return V1ClusterTrustBundleProjectionFromJSONTyped(json, false);
}

export function V1ClusterTrustBundleProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1ClusterTrustBundleProjection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'labelSelector': !exists(json, 'labelSelector') ? undefined : V1LabelSelectorFromJSON(json['labelSelector']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'optional': !exists(json, 'optional') ? undefined : json['optional'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'signerName': !exists(json, 'signerName') ? undefined : json['signerName'],
    };
}

export function V1ClusterTrustBundleProjectionToJSON(value?: V1ClusterTrustBundleProjection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'labelSelector': V1LabelSelectorToJSON(value.labelSelector),
        'name': value.name,
        'optional': value.optional,
        'path': value.path,
        'signerName': value.signerName,
    };
}

